import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {confirm} from 'devextreme/ui/dialog';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {DateHelperService, ScreenService} from '../../../../shared/services/general';
import {PatientEditable} from '../../models/order-entry/patient';
import {PatientService} from '../../services';

@Component({
  selector: 'app-patient-selector',
  templateUrl: './patient-selector.component.html',
  styleUrls: ['./patient-selector.component.scss'],
})
export class PatientSelectorComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() public control: AbstractControl | FormControl | null | undefined = null;
  @Input() public buttonMode = false;
  @Input() public disabled = false;

  public isPopupVisible = false;
  public selectedPatient?: PatientEditable;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(public dateHelper: DateHelperService,
              private host: ElementRef,
              private renderer: Renderer2,
              private route: ActivatedRoute,
              private router: Router,
              private screen: ScreenService,
              private patientService: PatientService) {
  }

  public ngOnInit() {
    this.control?.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(value => {
      if (value === undefined || value === null) {
        this.selectedPatient = undefined;
      }
    });

    if ((this.route.snapshot.paramMap as any).params.patientId !== undefined) {
      this.patientService.getPatient((this.route.snapshot.paramMap as any).params.patientId)
        .pipe(take(1)).subscribe(patient => {
        this.control?.setValue(patient);
        this.selectedPatient = patient;
      });
    }
  }

  public ngAfterViewInit(): void {
    if (this.buttonMode) {
      this.renderer.setStyle(this.host.nativeElement, 'width', '120px');
    } else {
      if (this.screen.sizes['screen-x-small']) {
        this.renderer.setStyle(this.host.nativeElement, 'width', '100%');
      } else {
        this.renderer.setStyle(this.host.nativeElement, 'width', '200px');
      }
    }
    this.control?.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(patient => this.selectedPatient = patient);
  }

  public showSearch(): void {
    if (!this.buttonMode) {
      this.isPopupVisible = true;
    } else {
      if (this.selectedPatient === undefined) {
        this.isPopupVisible = true;
      } else {
        const response = confirm('You will lose all your changes. Are you sure?', 'Lose Changes Alert');
        // @ts-ignore
        response.then(r => {
          if (r) {
            this.router.navigate(['secured/patients/form', {
              ...this.selectedPatient,
              redirectToPath: this.router.url,
            }]);
          }
        });
      }
    }
  }

  get PatientFullName(): string {
    return this.selectedPatient ? `${this.selectedPatient.lastName}, ${this.selectedPatient.firstName}` : '';
  }

  public closeDialog(patient: PatientEditable): void {
    if (patient) {
      this.selectedPatient = patient;
      this.control?.setValue(patient);
    }
    this.isPopupVisible = false;
  }

  public clear() {
    this.selectedPatient = undefined;
    this.control?.setValue(null);
  }

  get SearchBtnText(): string {
    return this.selectedPatient ? 'Edit Patient' : 'Select Patient';
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
